/*!
 * Mobile Genome (Development Release)
 * Copyright 2015 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('modules/media/media-test',['require','underscore','jquery','backbone','marionette','core/templates'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var _ = require('underscore');
  var $ = require('jquery');
  var Backbone = require('backbone');
  var Marionette = require('marionette');
  var templates = require('core/templates');

  /*****************************************************************************************************************///}

  var MediaTest = Marionette.ItemView.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    className: 'media-test',
    template: templates['modules/media/media-test-combined'],
    ui: {
      audio: '.btn-audio',
      video: '.btn-video',
      confirm: '.btn-continue',
    },
    events: {
      'click @ui.audio': 'audioPressed',
      'click @ui.video': 'videoPressed',
      'mouseup @ui.confirm': 'videoPressed',
      'touchstart @ui.confirm': 'videoPressed',
      'mousedown @ui.confirm': 'audioPressed',
      'touchend @ui.confirm': 'audioPressed',
      'click @ui.confirm': 'confirm'
    },
    radio: Backbone.Wreqr.radio.channel('global').vent,
    queued: null,
    audioConfirmed: false,
    videoConfirmed: false,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      this.queued = options.media;
      //alert(options);
      this.model = new Backbone.Model(options);
      //this.set('mediaType', options.mediaType);
    },

    audioPressed: function(e)
    {
      this.options.channel.play('silence.mp3', { available: true });
      this.audioConfirmed = true;
      //this.types.push('audio');

      $(e.currentTarget).addClass('pressed');

      if (this.videoConfirmed)
        this.$el.find('.btn-continue').removeAttr('disabled');
    },

    videoPressed: function(e)
    {
      this.options.channel.play('video_enable.mp4', { available: true });
      this.videoConfirmed = true;

      $(e.currentTarget).addClass('pressed');

      if (this.audioConfirmed)
        this.$el.find('.btn-continue').removeAttr('disabled');
    },

    confirm: function(e)
    {
      this.$el.find('.btn-continue').attr('disabled', 'disabled');
      var self = this;
      _.delay(function() {
        self.radio.trigger('media:playback:allowed', self.queued);
        self.destroy();
      }, 1000);
    }

  /*****************************************************************************************************************///}

  });

  return MediaTest;

});

